const BACKSTAGE_URL = import.meta.env.VITE_BACKSTAGE_URL ?? '';

export function buildBackstageUrl(path: string): string | null {
  if (!BACKSTAGE_URL) return null;
  return `${BACKSTAGE_URL.replace(/\/$/, '')}${path}`;
}

